import {Injectable} from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import {Observable, combineLatest} from 'rxjs';
import * as fromStore from '../../store';
import {Store} from "@ngrx/store";
import {DbStoreState} from "../../store";
import {filter, first, switchMap} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})


export class WorkspaceGuard implements CanActivate {

  constructor(
    private _router: Router,
    private _store: Store<DbStoreState>
  ) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

    return new Promise<boolean>((resolve, reject) => {
      this._store.select(fromStore.getUserLoaded)
        .pipe(
          filter((loaded: boolean) => loaded),
          switchMap(() => combineLatest(
            this._store.select(fromStore.getUser),
            this._store.select(fromStore.getCurrentWorkspace)
          )),
          first()
        )
        .pipe(first())
        .subscribe(([user, currentWorkspace]) => {
          const fromGoogleSignup = window.location.href.indexOf("finalize") > -1 || localStorage.getItem('dbStartAiParams') || localStorage.getItem('dbShowV2Finalize');
          if (fromGoogleSignup && route && route.data && route.data['pageId'] &&  ["start-ai-website-building", "fill-company-info", "v2-ai-website-building"].includes(route.data['pageId'])) {
            return resolve(true);
          }
          if (!user && (route.data['pageId'] === "checkout" || route.data['pageId'] === "checkout-ai" || route.data['pageId'] === "start-ai-website-building")) {
            return resolve(true);
          }
          if (currentWorkspace && route.data && route.data['workspaceRoles'] && route.data['workspaceRoles'].includes(currentWorkspace.roleId)) {
            return resolve(true);
          }
          if (currentWorkspace && route.data && route.data['workspaceRoles'] && !route.data['workspaceRoles'].includes(currentWorkspace.roleId) && route.data['pageId'] === 'upgrade-plan' && user && user.hostingTrialExpired) {
            return resolve(true);
          }
          this._router.navigate(['/websites']);
          resolve(true);
        });
    });
  }

}
